import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Table,
    Input,
    Space,
    // AutoComplete,
    // InputNumber,
} from 'antd';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
// import { usePostRequest } from '../../hooks/usePostRequest'

const { Search } = Input;

const CorporateReport = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState('');
    const [reportData, setReportData] = useState([])
    const [filterConfig, setFilterConfig] = useState({
        term: '',
        corporate_id: '',
    })

    async function fetchReportData  () {
        setIsLoading(true)
        const response = await UseGetRequest("reports/get_corporate_report", filterConfig);
        if (response?.data) {
            setReportData(response?.data?.member_corporates);
            setPageSize(response?.data?.size)
        } else {
            setReportData([])
            setPageSize('')
        }
        setIsLoading(false);
    }

    async function fetchExportExcel() {
        setIsLoading(true)
        const response = await UseGetRequest("reports/create_corporate_report_excel", filterConfig);
        if (response?.data) {
          const link = document.createElement('a');
          link.href = response.data.url;
          link.setAttribute('download', 'file.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          toast.error(response?.data?.message)
        }
        setIsLoading(false);
    }

    const defaultColumns = [
        {
            title: 'ID',
            dataIndex: 'corporate_no',
            align: 'center',
            key: 'corporate_no',
        },
        {
            title: 'Corporate Name',
            dataIndex: 'name',
            align: 'center',
            key: 'name',
        },
        {
            title: 'Certificate Number',
            dataIndex: 'certificate_no',
            align: 'center',
            key: 'certificate_no',
        },
        {
            title: 'Gender',
            children: [
              {
                title: 'Male',
                dataIndex: 'male',
                align: 'center',
                key: 'male',
                render: (_, record) => (
                    <div>
                        <div>
                            {record && record?.male_members?.map((data, index) => (
                                <div key={index}>
                                    - <strong>{data?.member_name}</strong>
                                </div>
                            ))}
                        </div>
                    </div>
                ),
              },
              {
                title: 'Female',
                dataIndex: 'female',
                align: 'center',
                key: 'female',
                render: (_, record) => (
                    <div>
                        <div>
                            {record && record?.female_members?.map((data, index) => (
                                <div key={index}>
                                    - <strong>{data?.member_name}</strong>
                                </div>
                            ))}
                        </div>
                    </div>
                ),
              },
            ],
        },
    ];

    const handleChange = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            term: e || '',
            page: 1,
          }
        ));
    };
        
    const handleEmpty = (e) => {
        if(e.target.value === ''){
          setFilterConfig((prev) => (
            {
              ...prev,
              term: e.target.value || '',
              page: 1,
            }
          ));
        }
    };

    const handleTableChange = (pagination) => {
        setFilterConfig((prev) => ({
            ...prev,
            page: parseInt(pagination.current),
            page_size: pagination.pageSize
            // total_records_per_page: pagination.pageSize,
        }));
    };

    useEffect(() => {
        fetchReportData();
        // fetchExportData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);

    return (
        <Layout className='page'>
            <Navbar navKey={'corporate_report'}/>
            <Layout className='content-container overflow-y custom-padding'>
                <Row className='responsive-tab-inline mb-4'>
                    <Col span={12} className='header-container'>
                        CORPORATE REPORT
                    </Col>
                    <Col span={12} className='mt-2 responsive-tab-width' align='end'>
                        <Space className='responsive-inline'> 
                            <Search
                                placeholder="Search Member"
                                size='medium'
                                onSearch={(e)=>handleChange(e)}
                                onChange={(e)=>handleEmpty(e)}
                                className='responsive-header-input'
                            />             
                            <Button 
                                className='excel-btn' 
                                size="large"
                                onClick={fetchExportExcel}
                            >
                                Export To Excel
                            </Button>
                        </Space>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Table
                            bordered
                            dataSource={reportData}
                            columns={defaultColumns}
                            loading={isLoading}
                            tablePages={10}
                            handleTableChange={handleTableChange}
                            filterConfig={filterConfig}
                            totalSize={pageSize}
                            isSearch={true}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default CorporateReport
